import React, { useEffect } from "react";
import ProUnAuth from "../../assets/svg/unAuth.svg";
import CoversureLogo from "../../assets/svg/coversure-logo.svg";
import { useDispatch } from "react-redux";
import { resetLogin } from "../../store/reducers/authentication";
const UnAuthentication = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetLogin());
  }, []);
  return (
    <div className="lg:pb-[80px] pt-[50px] px-[16px] pb-[16px]">
      <div className="flex justify-center flex-col">
        <img
          src={CoversureLogo}
          alt="CoversureLogo"
          className="h-[22px] lg:h-[44px]"
        />
        <div className="lg:text-[48px] lg:leading-[49px] text-text-color-4 font-extrabold pt-[12px] text-[24px] leading-[24px] text-center">
          ProSure
        </div>
      </div>
      <div className="flex items-center w-[100%]">
        <img
          src={ProUnAuth}
          alt="ProUnAuth"
          className="w-[112px] lg:w-[248px] lg:mt-[73px] mt-[48px] m-auto"
        />
      </div>
      <div className="mt-[24px] lg:mt-[50px] text-center">
        <div className="text-[14px] lg:text-[31px] lg:leading-[31px] leading-[18px] font-semibold text-text-color-5">
          Unauthorised access
        </div>
        <div className="lg:mt-[16px] mt-[8px] lg:text-[18px] text-[12px] lg:leading-[27px] leading-[18px] font-medium text-text-color-3">
          You do not have permission to access this resource
        </div>
      </div>
    </div>
  );
};

export default UnAuthentication;
